import styled, { css } from 'styled-components';
import * as C from '../../loggedout/shared-styles/Colors';
import { device } from '../../../utils/responsive_utilities';

export const BackButtonContainer = styled.div`
  position: fixed;
  top: 6.1rem;
  left: 13%;
  transform: translateY(-50%);
  border-radius: 50%;
  background-color: ${C.royal};
  height: 11.8rem;
  width: 11.8rem;
  z-index: 2;
  display: flex;
  justify-content: center;
  @media ${device.TabletLandscape}{
    left: 3.3rem;
  }
  @media ${device.Tablet}{
    left: 3.3rem;
  }
  @media ${device.Phone} {
    height: 8.5rem;
    width: 8.5rem;
    left: 1.5rem;
    top: 6.5rem;
  }
  @media ${device.PhoneTabletLandscape} {
    height: 7rem;
    width: 7rem;
    top: 0.5rem;
    left: 0.8rem;
  }
`;

export const AnimationContainer = styled.div`
  pointer-events: ${props => props.clickDisable ? 'none' : 'auto'};
`;

export const Button = styled.div`
  display: inline-flex;
  position: absolute;
  top: 72%;
  transform: translateY(-50%);
  justify-content: center;
  ${AnimationContainer} {
    width: 70%;
    height: 5rem;
    @media ${device.TabletLandscape}{
      height: 6.5rem;
      top: 8.5rem;
    }
    @media ${device.Tablet}{
      height: 8rem;
    }
    @media ${device.PhoneTabletLandscape}{
      height: 5rem;
    }
    ${(props) => props.isFlat ? 
      css` 
        cursor: default;
      ` :
      css` 
        cursor: pointer;
      `
    }
  }
`;